export default async function fetchData() {
  const response = await fetch(
    `${process.env.API_ENDPOINT}?acf_format=standard`
  );
  const rest = await response.json();
  return rest;
}
